module.exports = __webpack_public_path__ + "img/tag_红分赛事@2x.f838ba85.png";